<script lang="ts" setup>
    import { computed, ref } from "vue";
    import { Link } from "@inertiajs/vue3";
    import type { Cta } from "@/helpers/builder-init/index";
    import { getCtaLink } from "@/helpers/interfaces/Cta";
    import RothcoCta from "@/components/RothcoCta.vue";
    import { useRothcoBreakpoints } from "@/helpers/composables/useBreakpoints";
    import useImageOptimization from "@/helpers/composables/useImageOptimization";
    import RightArrow from "@icons/right-arrow.svg";
    const props = defineProps({
        togglePadding: {
            type: Boolean,
            default: false
        },
        textBelow: {
            type: Boolean,
            default: false
        },
        columns: {
            type: String,
            default: "four"
        },
        categories: {
            type: Array<Object>,
            default: []
        }
    });
    let columnNumber = computed(() => {
        if (props.columns == "two") {
            return "";
        } else {
            return props.columns;
        }
    })
    let breakpoints = useRothcoBreakpoints();
    let breakpointIsMobile = computed(()=>{
        return breakpoints.smaller('laptop').value;
    });

    let { optimize } = useImageOptimization();
</script>
<template>
    <div>
        <section
            id="category_launcher"
            :class="{
                'category-launchers': true,
                [columnNumber]: !!columnNumber,
                'alternative-padding': !props.togglePadding
            }"
        >
            <div
                v-for="(item, index) in props.categories"
                :key="index"
                class="category-launchers-item"
            >
                <div :class="`item-base ${!item.image ? 'item-no-image' : ''}`">
                    <Link :href="item.cta ? getCtaLink(item.cta).href : '#'" :style="item.cta ? `` : `pointer-events: none; cursor: default;`">
                    <component :is="item.image ? 'img' : 'div'"
                        id="category_image"
                        :src="optimize(item.image)"
                        :alt="item.image_alt"
                        :class="item.image ? 'item-image' : 'item-div'"
                    />
                    </Link>
                    <component :is="item.cta ? RothcoCta : 'div'" as="div" v-bind="item.cta ? getCtaLink(item.cta) : {}" ctaType="div"
                        id="headline_and_link"
                        html-slotted
                        :class="
                            props.textBelow
                                ? `animation-desk text-below`
                                : `animation-desk`
                        "
                        >
                        <div class="category-launcher">
                            <div class="fill category-launcher-fill">
                                <RightArrow
                                    alt="arrow right"
                                    class="carret category-launcher-carret"
                                    aria-label="hidden"
                                />
                                <div class="category-title-section">
                                    <p v-if="item.headline" class="headline-xs" id="headline_text">
                                        {{ item.headline }}
                                    </p>
                                    <div v-if="item.cta && item.cta.label" class="headline-xs category-cta">
                                        {{ item.cta.label }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </component>
                </div>
                <div class="no-animation">
                    <Link v-if="item.cta" :href="getCtaLink(item.cta).href" class="headline-xs" style="text-decoration: none;">{{ item.headline }}</Link>
                    <p v-else class="headline-xs">{{ item.headline }}</p>
                </div>
            </div>
        </section>
    </div>
</template>
